import { typedQueryClient, useTypedQuery } from "hooks";
import { UnlinkedExactLicensesQueryKeys } from "modules/UnlinkedExactLicensesDashboard/queryKeys";
import { UNLINKED_EXACT_LICENSES_STORAGE_KEYS } from "modules/UnlinkedExactLicensesDashboard/storageKeys";
import { getPreference } from "utils/common";

import type { UnlinkedExactLicensesDashboardFilters } from "modules/UnlinkedExactLicensesDashboard/queryKeys";

export const useGetUnlinkedLicensesFilters = () =>
  useTypedQuery({
    queryKey: UnlinkedExactLicensesQueryKeys.filters,
    initialData: {
      ignored: getPreference(UNLINKED_EXACT_LICENSES_STORAGE_KEYS.IgnoredUnlinkedExactLicensesPreference, false),
      exact_category_types: getPreference(UNLINKED_EXACT_LICENSES_STORAGE_KEYS.ExactCategoryTypesPreference, [])
    }
  }).data;

export const setUnlinkedLicensesFilters = (filters: UnlinkedExactLicensesDashboardFilters) =>
  typedQueryClient.setQueryData(UnlinkedExactLicensesQueryKeys.filters, { ...typedQueryClient.getQueryData(UnlinkedExactLicensesQueryKeys.filters), ...filters });
